import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Page from "src/components/Report/Page";

export default function Page7() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const jobId = params.get("id");

    let maharathayeFanavari;
    if (JSON.parse(localStorage?.data)?.[jobId]?.maharathayeFanavari) {
        maharathayeFanavari = JSON.parse(localStorage?.data)?.[jobId].maharathayeFanavari
    } else {
        maharathayeFanavari = [];
    }
    // let zaban;
    // if (localStorage?.zabanha) {
    //     zaban = JSON.parse(localStorage?.zaban)
    // } else {
    //     zaban = [];
    // }
    // console.log(zaban);

    let items = {}
    if (JSON.parse(localStorage?.data)?.[jobId]?.zabanha) {
        items = JSON.parse(localStorage?.data)?.[jobId]?.zabanha;
    } else {
        items = {}
    }
    if (Object.keys(items).length) {
        for (const key in items) {
            Object.keys(items[key]).forEach((i) => {
                if (!Object.values(items[key][i]).includes(true)) {
                    // items[key][i] = "نامشخص"
                    return
                }
                Object.keys(items[key][i])?.forEach((option) => {

                    if (items[key][i][option]) {

                        items[key][i] = option
                    }
                })
            })
        }
    }

    const languageImgLink = {
        خواندن: "./assets/img/reading.png",
        نوشتن: "./assets/img/writing.png",
        مکالمه: "./assets/img/speaking.png",
        ترجمه: "./assets/img/translation.png",
    }

    return (
        <Page pageNumber={10}>
            <div className="font-bold text-lg">
                مهارت زبان‌های خارجی :
            </div>
            {
                Object.keys(items).length && Object.keys(items)?.map((language, index) => {
                    return (
                        <div key={index} className="flex flex-col w-full">
                            <div className="w-full bg-[#5b5cff] text-white rounded p-2 flex justify-center items-center ">
                                سطح زبان {language} مورد نیاز
                            </div>
                            <div className="flex">
                                {
                                    items && items[language] && Object.keys(items[language])?.map((i, index) => {
                                        return (<div key={index} className="border-l border-solid border-gray-400 flex flex-col gap-2 justify-center items-center rounded w-full bg-gray-200">
                                            <div className="flex flex-col justify-center items-center gap-2 p-2">
                                                <span>{i}</span>
                                                <img src={languageImgLink?.[i]} className="w-[60px]" />
                                            </div>
                                            <div className="bg-gray-300 w-full flex justify-center items-center p-2">
                                                {items?.[language]?.[i] instanceof Object ? "---" : items?.[language]?.[i]}
                                            </div>
                                        </div>)
                                    })
                                }
                            </div>
                        </div>
                    )
                })
            }


            <div className="font-bold text-lg mt-20">
                اهم مهارت‌های فناوری اطلاعات مورد نیاز:
            </div>
            <div className="relative">
                <div className="flex flex-col w-full pl-4">
                    <div className="w-full h-[80px] bg-blue-300 text-black flex items-center p-4">تسلط</div>
                    <div className="w-full h-[80px] bg-blue-200 text-black flex items-center p-4">توانایی</div>
                    <div className="w-full h-[80px] bg-blue-100 text-black flex items-center p-4">آشنایی</div>
                </div>
                <div className="flex flex-col">
                    <div className="absolute top-[30px] left-0">- 3</div>
                    <div className="absolute top-[110px] left-0">- 2</div>
                    <div className="absolute top-[190px] left-[4px]">- 1</div>
                    <div className="w-full pl-4">
                        <div className="w-full h-[2px] bg-gray-400"></div>
                    </div>
                    <div className="h-[240px] w-[2px] bg-gray-400 absolute left-[15px] top-0"></div>
                </div>
                <div className="flex gap-2 absolute -bottom-[22px] left-[25px]">
                    {
                        Object.keys(maharathayeFanavari).map((key, index) => {

                            if (maharathayeFanavari[key].value >= 3) {
                                let height = 0;
                                maharathayeFanavari[key].value == 3 ? height = 40 : maharathayeFanavari[key].value == 4 ? height = 120 : height = 200
                                return (
                                    <div className="flex flex-col gap-2 items-center justify-end w-[45px]">
                                        <div className="w-[15px]  bg-blue-700 rounded-t relative" style={{ height: `${height}px` }}>
                                            {/* <span className="absolute -top-[15px] -left-[7px] text-3xl text-red-600">x</span> */}
                                        </div>
                                        <div className="w-[50px] text-xs -rotate-45 -ml-14" style={{ whiteSpace: "nowrap", transformOrigin: "100% 0%" }}>{key}</div>
                                    </div>
                                )
                            }
                        })
                    }

                </div>
            </div>
            <div className="font-bold text-lg mt-10">
                مهارت‌های فناوری اطلاعات مورد نیاز:
            </div>
            <div className="flex flex-wrap gap-2">
                {Object.keys(maharathayeFanavari).map((key, index) => {
                    if (maharathayeFanavari[key].value >= 2) {

                        return (<span className="odd-color bg-gray-300 rounded p-2" key={index}>{key}</span>)
                    }
                })}
            </div>
        </Page>
    )
}